module.exports = __webpack_public_path__ + "static/img/2.de0d481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/cpzl/2.jpg
// module id = 9TgC
// module chunks = 0